module.exports = __webpack_public_path__ + "media/images/play-button-alt-eea51b9b545e682b6ac72a4f03d7b2fd.svg";